import { Link } from "@/i18n/navigation";
import { getCdnImagePath } from "@/utils/bus/getCdnImagePath";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import { useState } from "react";

export default function CityThemeList({ item }) {
  if (!item) return null;

  const href = item.RedirectUrl || "#";
  const displayName = item.DisplayName || item.ThemeName || "";
  const iconClass = item.IconClass || item.ThemeCssClass || "hotel";

  const [imageError, setImageError] = useState(false);

  // Default fallback SVG component
  const DefaultIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 60 60" fill="none">
      <path d="M21 17.25L6 30L5.25 32.25V41.25V50.25L6.75 53.25L7.5 54L20.25 54.75H31.5L35.25 54L36.75 51V30.75L21 17.25Z" fill="#E1E1EF" />
      <path d="M18 39.75V33.75H18.75H24L24.75 35.25V38.25L24 39.75L21 40.5L18 39.75Z" fill="white" />
      <path d="M20.5498 15.9668C20.8125 15.7479 21.1885 15.7479 21.4512 15.9668L21.4863 15.9961L21.4951 15.9863L40.21 31.7061V31.707C40.5086 31.9618 40.551 32.3985 40.2979 32.6953C40.0438 32.9931 39.6064 33.0285 39.3086 32.7832L37.5371 31.3027L37.4551 31.2334V49.5C37.4551 52.3693 35.1241 54.7002 32.2549 54.7002H9.75488C6.88573 54.7001 4.55469 52.3692 4.55469 49.5V31.2334L4.47266 31.3027L2.70117 32.793C2.40305 33.0382 1.95715 33.0022 1.71289 32.7061C1.46726 32.4078 1.50319 31.9611 1.7998 31.7168L20.5498 15.9668ZM37.5049 6.0498C37.7055 6.0498 37.8896 6.13694 38.0215 6.27734L51.9902 21.7178C52.291 22.0459 52.455 22.4747 52.4551 22.9121C52.4551 23.8973 51.6613 24.7002 50.6768 24.7002H45.002L45.0693 24.7822L55.0352 36.7539L55.0361 36.7549C55.3091 37.0735 55.4551 37.4837 55.4551 37.9033C55.455 38.8975 54.6524 39.7002 53.6582 39.7002H46.6328L46.7129 39.7842L57.9619 51.708V51.709C58.2725 52.047 58.4453 52.4759 58.4453 52.9316C58.4451 53.907 57.6521 54.7002 56.6768 54.7002H40.5576C40.8414 54.2525 41.0852 53.7885 41.2881 53.2998H56.6865C56.8921 53.2997 57.0545 53.1371 57.0547 52.9316C57.0547 52.8608 57.0375 52.7873 57 52.7266L56.9561 52.6709L44.498 39.4814C44.3057 39.2714 44.2618 38.9734 44.3672 38.7188C44.4718 38.4665 44.7247 38.2999 45.0049 38.2998H53.6582C53.8724 38.2998 54.0546 38.1286 54.0547 37.9033C54.0547 37.8067 54.0218 37.72 53.958 37.6455L42.9717 24.4463C42.7968 24.2364 42.7612 23.9474 42.875 23.7021C42.9887 23.4573 43.2339 23.2999 43.5049 23.2998L50.6768 23.3096C50.8834 23.3096 51.0547 23.1361 51.0547 22.9219C51.0547 22.8252 51.0228 22.7385 50.959 22.6641L50.958 22.6631L37.542 7.83203L37.5049 7.79102L37.4678 7.83203L29.4658 16.6836L28.3887 15.7822L36.9883 6.27832C37.1201 6.1377 37.3042 6.04987 37.5049 6.0498ZM18.7549 32.2998H23.2549C24.4741 32.2998 25.4551 33.2807 25.4551 34.5V39C25.4551 40.2193 24.4741 41.2002 23.2549 41.2002H18.7549C17.5357 41.2001 16.5547 40.2192 16.5547 39V34.5C16.5547 33.2808 17.5357 32.2999 18.7549 32.2998ZM18.7549 33.7002C18.3149 33.7003 17.9551 34.06 17.9551 34.5V39C17.9551 39.44 18.3149 39.7997 18.7549 39.7998H23.2549C23.695 39.7998 24.0547 39.4401 24.0547 39V34.5C24.0547 34.0599 23.695 33.7002 23.2549 33.7002H18.7549ZM36.0547 30.0518L36.0371 30.0371L21.0371 17.4365L21.0049 17.4102L20.9727 17.4365L5.97266 30.0371L5.95508 30.0518V49.5C5.95508 51.5994 7.6555 53.2997 9.75488 53.2998H32.2549C34.3544 53.2998 36.0547 51.5995 36.0547 49.5V30.0518Z" fill="#01007F" stroke="#01007F" strokeWidth="0.1" />
    </svg>
  );
  // Get icon element based on IconClass
  const getIconElement = () => {
    // If no iconClass, show default
    if (!iconClass) {
      return <DefaultIcon />;
    }

    // Check if it's a FontAwesome icon class (starts with 'fa-')
    if (iconClass.startsWith('fa-')) {
      // Extract icon name from class (e.g., 'fa-rings-wedding' -> 'rings-wedding')
      const iconName = iconClass.replace('fa-', '');
      const iconKey = iconName.replace(/-/g, '');

      // Try to find the icon in FontAwesome kit
      try {
        const icon = byPrefixAndName.far[iconKey] || byPrefixAndName.fas[iconKey] || byPrefixAndName.fal[iconKey];
        if (icon) {
          return <FontAwesomeIcon className="text-[40px] text-primary" icon={icon} />;
        }
      } catch (error) {
        console.warn(`FontAwesome icon not found: ${iconKey}`);
      }
    }

    // If image failed to load, show default
    if (imageError) {
      return <DefaultIcon />;
    }

    // Use SVG file from public/images/svg
    // Convert IconClass to SVG filename (e.g., 'golf' -> 'golf.svg', 'tent-new' -> 'tent-new.svg')
    const svgFileName = `${iconClass}.svg`;
    const svgPath = getCdnImagePath(`/saka/hotel/${svgFileName}`);

    return (
      <Image
        src={svgPath}
        alt={displayName || 'Icon'}
        width={40}
        height={40}
        className="object-contain"
        onError={() => {
          setImageError(true);
        }}
      />
    );
  };
  return (
    <Link
      href={href}
      className="flex items-center gap-4 hover:opacity-80 transition-opacity"
    >
      {/*  <span className="w-16 h-16 bg-background-global rounded-[6px] flex justify-center items-center shrink-0">
        <FontAwesomeIcon
          className="text-[30px] text-primary"
          icon={byPrefixAndName.fak[iconClass]}
        />
      </span>*/}
      <div className="flex items-center justify-center bg-background-global rounded-[6px] shrink-0 w-16 h-16">
        {getIconElement()}
      </div>
      <span className="flex-1 text-foreground text-base lg:text-lg font-medium truncate">
        {displayName}
      </span>
    </Link>
  );
}
